<script setup lang="ts">
import { computed } from "vue";
import { useRoute } from "vue-router";
type TabType = "referrer" | "referred";
const referrerRoute = { name: "ReferPromotion", query: { tab: "referrer" } };
const referredRoute = { name: "ReferPromotion", query: { tab: "referred" } };

const route = useRoute();

const activeTab = computed(() => {
  return route.query.tab as TabType;
});

const isActiveTab = (expectedTab: TabType) => {
  return activeTab.value === expectedTab;
};
</script>

<template>
  <BNav fill>
    <BNavItem
      :to="referrerRoute"
      class="nav-item"
      :active="isActiveTab('referrer')"
    >
      招待の手順
    </BNavItem>
    <BNavItem
      :to="referredRoute"
      class="nav-item"
      :active="isActiveTab('referred')"
    >
      招待された方
    </BNavItem>
  </BNav>
</template>
<style lang="scss" scoped>
.nav {
  height: inherit;

  .nav-item {
    font-size: 14px;
    font-weight: 500;

    :deep(a) {
      padding: 14px 0;
      color: $gray-05;
      border-bottom: 1px solid $gray-03;

      &.active,
      &:hover {
        color: #31373f;
        border-bottom: 3px solid #fbce5a;
      }
    }
  }
}
</style>
